<template>
  <NavBarSelect>
    <template #activator>{{ $tt('page.contact') }}</template>

    <AppListItem :href="whatsappLink" target="_blank">
      <template #prepend>
        <NavBarContactLinksIcon icon="mdi:whatsapp" />
      </template>
      <template #title>
        {{ $tt('whatsapp') }}
      </template>
    </AppListItem>

    <AppListItem v-if="telegram" :href="telegram" target="_blank">
      <template #prepend>
        <NavBarContactLinksIcon icon="uil:telegram-alt" />
      </template>
      <template #title>
        {{ $tt('socials.telegram') }}
      </template>
    </AppListItem>

    <AppListItem :href="'tel:' + phone.raw">
      <template #prepend>
        <NavBarContactLinksIcon icon="uil:phone" />
      </template>
      <template #title>
        {{ phone.display }}
      </template>
    </AppListItem>

    <AppListItem :href="'mailto:' + supportEmail">
      <template #prepend>
        <NavBarContactLinksIcon icon="clarity:email-line" />
      </template>
      <template #title>
        {{ supportEmail }}
      </template>
    </AppListItem>

    <AppListItem @click="openChatboxBus.emit">
      <template #prepend>
        <NavBarContactLinksIcon icon="bx:chat" />
      </template>
      <template #title>
        {{ $tt('chat') }}
      </template>
    </AppListItem>

    <AppListItem to="/contact">
      <template #prepend>
        <NavBarContactLinksIcon icon="bx:support" />
      </template>
      <template #title>
        {{ $tt('support') }}
      </template>
    </AppListItem>

    <div class="flex col gap-4 socials">
      <h5>{{ $tt('follow_us') }}</h5>
      <SocialLinks primary />
    </div>
  </NavBarSelect>
</template>

<script setup lang="ts">
const { supportEmail, whatsappLink, telegram, phone } = useCommunication();
const { openChatboxBus } = useEmitter();
</script>

<style scoped>
.socials {
  margin-top: var(--space-6);
  margin-bottom: var(--space-4);
  padding-inline: var(--space-6);
  justify-content: center;
  align-items: center;
}
</style>